const NAMES = {
  MINIMUM_SERVICE_CHARGE: 'Minimum Service Charge',
  MAX_COST_OFFSET       : 'Max Cost Offset'
}

export {
  NAMES
}